<template>
  <v-container fluid grid-list-md id="page-body" :class="{'px-0': $vuetify.breakpoint.smAndDown}">
    <newscards newsSource="the-lad-bible"></newscards>
    <newscards newsSource="entertainment-weekly"></newscards>
    <newscards newsSource="mtv-news"></newscards>

    <newscards newsSource="ign"></newscards>
    <newscards newsSource="polygon"></newscards>
    <newscards newsSource="reddit-r-all"></newscards>
  </v-container>
</template>

<script>
export default {
  name: 'Entertainment'
}
</script>
